import { useState, useContext, useCallback } from 'react';
import ApplicationContext from '../ApplicationContext';
import CartContext from '../CartContext';
import _ from '../LodashImports';
import { track } from '../../external_dependencies/analytic';
import constants from '../../config/constants';

const initialData = {
  error: null,
  loading: false,
};

const useAddProductToCart = () => {
  const { appCtx } = useContext(ApplicationContext.Context);
  const { cart } = useContext(CartContext.Context);
  const [addState, setAddState] = useState(initialData);

  const addToCart = useCallback(
    async (values, product) => {
      setAddState((prevAddState) => ({
        ...prevAddState,
        error: null,
        loading: true,
      }));

      const isInternational = _.get(product, 'availability.internationalShipping', '');

      try {
        const addToCartPromise = cart.addProduct({
          appCtx,
          replaceCartItems: true,
          products: [
            {
              ...values,
              isInternational: !!isInternational,
            },
          ],
          showLightBox: false,
        });

        const response = await addToCartPromise;
        if (response) {
          const errorCode = response?.[0].code || '';
          if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
            throw new Error('Unauthorized');
          }
        }

        track('addToCart');
        setAddState((prevState) => ({
          ...prevState,
          error: null,
          loading: false,
        }));
      } catch (error) {
        setAddState((prevState) => ({
          ...prevState,
          error: error.message,
          loading: false,
        }));
      }
    },
    [addState]
  );

  return { addState, addToCart };
};

const useRemoveProductFromCart = () => {
  const { appCtx } = useContext(ApplicationContext.Context);

  const { cart } = useContext(CartContext.Context);
  const [removeState, setRemoveState] = useState(initialData);

  const removeFromCart = async (products) => {
    setRemoveState((prevRemoveState) => ({
      ...prevRemoveState,
      error: null,
      loading: true,
    }));
    try {
      const removeFromCartPromise = cart.removeProduct({
        appCtx,
        products,
      });

      const response = await removeFromCartPromise;
      if (response) {
        const errorCode = response?.[0].code || '';
        if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
          throw new Error('Unauthorized');
        }
      }
      setRemoveState((prevState) => ({
        ...prevState,
        error: null,
        loading: false,
      }));
    } catch (error) {
      setRemoveState((prevState) => ({
        ...prevState,
        error: error.message,
        loading: false,
      }));
    }
  };

  return { removeState, removeFromCart };
};

export { useAddProductToCart, useRemoveProductFromCart };
